export default "__VITE_ASSET__CwjCAXa4__"